import type { Components } from '@mui/material/styles'
import { CaretLeft as CaretLeftIcon } from '@phosphor-icons/react/dist/ssr/CaretLeft'
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight'

import { useMediaQuery } from '@/hooks/use-media-query'

import type { Theme } from '../types'

function PreviousButtonIcon() {
	const isMobile = useMediaQuery('down', 'sm')
	return <CaretLeftIcon fontSize={isMobile ? 'var(--fontSize-xl)' : 'var(--fontSize-md)'} />
}

function NextButtonIcon() {
	const isMobile = useMediaQuery('down', 'sm')
	return <CaretRightIcon fontSize={isMobile ? 'var(--fontSize-xl)' : 'var(--fontSize-md)'} />
}

export const MuiTablePagination = {
	defaultProps: {
		slotProps: {
			actions: {
				nextButtonIcon: { component: NextButtonIcon },
				previousButtonIcon: { component: PreviousButtonIcon },
			},
			select: { size: 'small', variant: 'outlined' },
		},
	},
	styleOverrides: {
		input: { marginRight: '16px', padding: 0 },
		actions: ({ theme }) => ({
			[theme.breakpoints.down('sm')]: {
				display: 'flex',
				alignItems: 'center',
				gap: theme.spacing(1.5),
			},
		}),
	},
} satisfies Components<Theme>['MuiTablePagination']
